export const createGameCardAnimatorSlice = ()=>(set, get, api)=>({
            gameCardAnimator: {
                cardsAnimating: [],
                setCardsAnimating: (cardsAnimating)=>{
                    set({
                        gameCardAnimator: {
                            ...get().gameCardAnimator,
                            cardsAnimating: cardsAnimating
                        }
                    });
                },
                addCard: (card)=>{
                    if (!get().gameUserSettings.isAnimationsEnabled) {
                        var _card_onComplete;
                        (_card_onComplete = card.onComplete) === null || _card_onComplete === void 0 ? void 0 : _card_onComplete.call(card, 0);
                        return;
                    }
                    set({
                        gameCardAnimator: {
                            ...get().gameCardAnimator,
                            cardsAnimating: [
                                ...get().gameCardAnimator.cardsAnimating,
                                card
                            ]
                        }
                    });
                },
                removeCard: (id)=>{
                    set({
                        gameCardAnimator: {
                            ...get().gameCardAnimator,
                            cardsAnimating: get().gameCardAnimator.cardsAnimating.filter((card)=>card.id !== id)
                        }
                    });
                },
                forceAnimationComplete: (id)=>{
                    var _cardAnimating_onComplete;
                    const cardAnimating = get().gameCardAnimator.cardsAnimating.find((card)=>card.id === id);
                    if (cardAnimating) (_cardAnimating_onComplete = cardAnimating.onComplete) === null || _cardAnimating_onComplete === void 0 ? void 0 : _cardAnimating_onComplete.call(cardAnimating, cardAnimating.id);
                }
            }
        });
